<div class="grid grid-cols-[60px_1fr] items-center mb-6">
  <button (click)="goBack()" class="flex justify-self-start">
    <ion-icon
      name="arrow-back-outline"
      class="custom-select-icon mr-2 text-[24px]"
    ></ion-icon>
  </button>
  <h1 class="heading">{{ title }}</h1>
</div>
